var _style, _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 113",
    style: {
      enableBackground: "new 0 0 90 113"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    className: "aw_svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#FFFFFF;} ")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.8,31.7 61.8,31.7 61.8,31.7 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,10.5C82.5,2.6,56,0,44.7,0C33.3,0,6.8,2.6,2.1,10.5C-2.5,18.2,1.8,75.9,2,78.3c0,0.2,0.1,6.1,5.3,11.2 c4.4,4.3,23.6,20.8,37.2,23.8l0.2,0l0.2,0c13.5-3,32.8-19.6,37.2-23.8c5.2-5.1,5.3-11,5.3-11.1C87.5,75.9,91.8,18.2,87.2,10.5z M44.7,111.5c-13-3-32.1-19.4-36.1-23.3c-4.7-4.5-4.7-9.8-4.8-10C2.6,61.7,0.1,17.4,3.7,11.4c4.1-6.8,28.7-9.6,41-9.6 c12.3,0,36.9,2.8,41,9.6c3.6,6,1.1,50.2-0.1,66.9c0,0.1-0.1,5.4-4.7,9.9C76.7,92.1,57.6,108.5,44.7,111.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRg1);
export default __webpack_public_path__ + "static/media/rg1.c97ab3390dda424c6e19ea2825e4ffab.svg";
export { ForwardRef as ReactComponent };